// src/api/kbDocQaitems.js
import { aicsHttp } from '../axios'

export function list_qa_items(docId, keyword, pageNum, pageSize) {
  const safeDocId = Number(docId) || 0;
  
  // 改为 GET 请求，匹配 getQaItems 方法
  return aicsHttp({
    url: `/aics/kb_doc/qa_items/${safeDocId}`,
    method: 'get',  // 改为 GET
    params: {
      keyword: keyword || '',
      pageNum: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10
    }
  })
}

/**
 * 保存问答对（新增或更新）
 * @param {Object} item - 问答对数据
 * @param {number} item.doc_id - 文档ID
 * @param {string} item.question - 问题
 * @param {string} item.anwser - 答案
 * @param {number} [item.id] - 问答对ID（更新时需要）
 * @param {number} [item.no] - 序号
 * @returns {Promise}
 */
export function save_qa_items(item) {
  return aicsHttp({
    url: '/aics/kb_doc/qa_items',
    method: 'post',
    data: {
      doc_id: Number(item.doc_id) || 0,
      question: String(item.question || ''),
      anwser: String(item.anwser || ''),
      id: item.id ? Number(item.id) : undefined,
      no: item.no ? Number(item.no) : undefined,
       tenant_id: item.tenant_id ? Number(item.tenant_id) : undefined 
    }
  })
}
/**
 * 嵌入问答对
 * @param {Object} item - 问答对数据
 * @param {string} item.target_workspace_slug - 工作区slug
 * @param {number} item.doc_id - 文档ID
 * @param {string} item.question - 问题
 * @param {string} item.anwser - 答案
 * @param {number} [item.id] - 问答对ID（更新时需要）
 * @param {number} [item.no] - 序号
 * @returns {Promise}
 */
export function embed_qa_items(item) {
  return aicsHttp({
    url: '/aics/kb_doc/embed_qa_items',
    method: 'post',
    data: {
      doc_id: Number(item.doc_id) || 0,
      question: String(item.question || ''),
      anwser: String(item.anwser || ''),
      id: item.id ? Number(item.id) : undefined,
      no: item.no ? Number(item.no) : undefined,
      target_workspace_slug: item.target_workspace_slug
    }
  })
}
/**
 * 删除问答对
 * @param {number} id - 问答对ID
 * @returns {Promise}
 */
export function deleteQaitem(id) {
  return aicsHttp({
    url: `/aics/kb_doc/qa_item/${Number(id)}`,
    method: 'delete'
  })
}

// 获取问答对文档详情
export async function getQADocumentDetail(kbDocId) {
          console.log("getQADocumentDetail",kbDocId);
          const response = await aicsHttp.get(
            `/aics/kb_doc/${kbDocId}`,
          );

            // 统一处理响应格式
            if (response==null || response.status !== 200) {
              throw new Error(response.data.message || '获取儿女大队信息失败');
            }
            return response.data;
    }